// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataTextInput } from '@furo/data-input/src/furo-data-text-input.js';

export class FormFuroFatString extends FuroDataTextInput {}

window.customElements.define('form-furo-fat-string', FormFuroFatString);
